var _path, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrapUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.929 25.184",
    height: 95.185,
    width: 294.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.00012,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M42.237 10.703c-.59-.073-1.156-.495-1.421-1.063-.143-.306-.147-.331-.154-1.179l-.006-.754h-.184c-.213 0-.232-.01-.278-.152-.036-.11-.336-1.083-.39-1.268a30.146 30.146 0 0 0-.123-.395l-.08-.255V4.625c0-.691.005-1.024.018-1.048a.182.182 0 0 1 .08-.06l.06-.026V1.938l.043-.043c.042-.042.051-.044.3-.044.237 0 .257-.002.257-.032 0-.018.02-.051.045-.075l.046-.043.638-.005c.699-.005.706-.004.751.098l.025.057h.234c.252 0 .309.013.34.082.013.03.02.285.02.81 0 .73 0 .766.032.766.017 0 .05.018.071.041l.04.042-.001 1.027v1.027l-.108.356a139.863 139.863 0 0 1-.354 1.149c-.136.441-.159.502-.197.529-.028.02-.086.026-.21.026h-.173v.675c0 .6.004.688.032.792a.869.869 0 0 0 .612.609c.098.03.188.032 1.217.032.837 0 1.134-.006 1.206-.022a.882.882 0 0 0 .664-.67c.021-.101.025-.66.025-3.72V1.8l.043-.05.043-.049h.73l.085.1-.005 3.689-.005 3.69-.041.15a1.863 1.863 0 0 1-1.59 1.374c-.204.022-2.163.02-2.337 0zm2.502-.32c.568-.137.97-.522 1.127-1.08l.04-.14.004-3.586.005-3.585h-.3v3.502c0 3.905.008 3.642-.124 3.915a1.241 1.241 0 0 1-.57.58c-.249.121-.23.12-1.484.123-1.264.004-1.215.007-1.489-.124a.937.937 0 0 1-.32-.232 1.21 1.21 0 0 1-.32-.497c-.04-.11-.04-.138-.05-.829l-.009-.714-.293-.01.006.754.006.755.05.15c.14.417.386.708.76.895.313.156.377.162 1.711.156.976-.004 1.145-.008 1.25-.033zm-2.95-3.121.044-.146-.172-.009c-.149-.007-.179-.014-.212-.048a.15.15 0 0 1 0-.203c.035-.036.061-.04.26-.049l.222-.009.043-.132c.023-.073.042-.138.042-.145 0-.007-.114-.014-.255-.014-.242 0-.257-.002-.303-.041a.14.14 0 0 1 0-.217c.047-.04.058-.041.353-.041h.305l.045-.15.045-.15h-.35c-.342 0-.35-.001-.398-.042a.14.14 0 0 1 0-.216c.048-.042.054-.042.445-.042h.396v-.3h-.396c-.391 0-.397 0-.445-.042-.037-.032-.048-.057-.048-.108 0-.05.011-.076.048-.108.048-.041.054-.042.445-.042h.396v-1.2h-.309l-.03.102c-.059.2-.25.43-.449.537a.897.897 0 0 1-.617.078c-.3-.08-.582-.355-.658-.641l-.02-.075H39.9v1.2h.813l.043.042c.048.048.058.14.02.188-.047.062-.093.069-.487.069h-.39v.3h.807l.047.043c.05.047.062.137.024.187-.047.062-.096.07-.435.07-.185 0-.336.005-.336.013 0 .007.019.072.042.145l.042.132.315.01c.173.005.317.011.319.013.083.075.099.164.042.235-.033.04-.047.042-.307.05l-.273.01.045.145.045.145h.201c.2 0 .256.013.3.07.037.047.027.14-.021.187-.04.04-.056.043-.212.043a.607.607 0 0 0-.168.012c0 .016.073.26.082.275.005.007.296.013.648.013h.64zm-.423-3.06a.717.717 0 0 0 .153-.101c.067-.061.162-.218.162-.269 0-.018-.116-.023-.583-.023h-.583l.012.04a.561.561 0 0 0 .34.36c.085.036.122.041.258.036a.651.651 0 0 0 .24-.043zm-.726-.851v-.142h-.08c-.105 0-.176-.038-.2-.107-.012-.036-.02-.222-.02-.504v-.447h-.282v1.34h.582zm.618-.112c0-.247 0-.254.044-.294.034-.032.07-.044.15-.05l.106-.008-.004-.443-.005-.443-.89-.01v.9h.08c.098 0 .18.04.202.1.01.024.017.146.017.272v.228h.3zm.9-.418v-.67h-.3v.475c0 .474 0 .476-.042.524-.035.04-.059.05-.15.056l-.108.008v.278h.6z",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.328,
    strokeDasharray: "0.98425, 0.328083",
    d: "M28.647 6.213h8.833",
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 0.328083,
      strokeMiterlimit: 4,
      strokeDasharray: ".98425,.328083",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.265,
    d: "M60.997 12.223c-.586-.123-1.096-.452-1.399-.9-.154-.23-.34-.666-.322-.759.01-.057.628-.06 9.26-.06 8.63 0 9.248.003 9.259.06.007.033-.033.172-.087.308-.285.718-.861 1.19-1.651 1.353-.325.067-.58.069-7.54.067-6.86-.002-7.218-.005-7.52-.069zm8.914-.833v-.326H67.16v.652h2.75zm-8.909-1.705-.105-.113V5c0-3.211.012-4.6.04-4.66a.403.403 0 0 1 .14-.146c.095-.056.66-.06 7.458-.06s7.363.004 7.457.06c.057.033.12.099.142.146.027.06.04 1.449.04 4.66v4.574l-.106.112-.105.112H61.107zm13.86-4.711.008-3.502H62.2v3.487c0 1.918.011 3.498.024 3.511.014.014 2.86.02 6.326.015l6.302-.009z",
    style: {
      fill: "none",
      stroke: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.328,
    strokeDasharray: "0.983929, 0.327976",
    d: "M48.327 6.213h8.833",
    style: {
      fill: "none",
      stroke: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.99,
    transform: "matrix(.0885 0 0 .0885 4.057 -5.827)",
    style: {
      fill: "none",
      stroke: "#dcdcdc"
    }
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M207.309 93.615c2.15 2.23.726 11.163-.374 13.797 0 0-7.03 27.557-12.59 48.297-5.55 20.705-8.025 36.754-13.432 42.244M1.633 93.613c-2.15 2.23-.725 11.163.374 13.797 0 0 7.03 27.557 12.59 48.297 5.55 20.705 8.025 36.754 13.432 42.244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m193.85 155.548-25.103.149c-.768-.705.018-2.082-1.058-2.514h-62.707m-89.884 2.365 25.102.149c.768-.705-.018-2.082 1.058-2.514h62.707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m122.178 105.733.05 23.166c.002.587.072 1.336-.892 1.303l-3.389-.02c.042.838-.564 1.184-1.492 1.189l-8.786.025c-.633-.021-1.2-.219-1.39-1.025l-1.212.008m-18.3-24.646-.05 23.166c-.002.587-.072 1.336.892 1.303l3.389-.02c-.041.838.564 1.184 1.492 1.189l8.787.025c.632-.021 1.199-.219 1.39-1.025l1.212.008"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 2.98951,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    strokeLinejoin: "round",
    d: "m105.08 182.43 76.673-.08 67.461-1.473s4.232-1.762 4.186-10.448l-.437-83c-.008-1.568.184-6.095-4.133-9.036l-41.606-.448-27.927 12.038-56.976.443-.137-30.611c-.004-.787-.857-1.826-2.143-1.826h-15.063m-.882 124.44-76.673-.08-67.461-1.473s-4.233-1.762-4.187-10.448l.438-83.001c.008-1.567-.185-6.094 4.132-9.035l41.606-.448 27.927 12.038 56.976.442.137-30.61c.004-.787.858-1.827 2.143-1.827h15.063",
    transform: "translate(-.115 15.436)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.571 197.765c.065.671-.975.932-1.8.928-7.441.03-5.644.044-7.879.016-1.026-.005-1.674-.34-1.663-.85m-208.85-.094c-.065.671.976.932 1.8.928 7.442.03 5.645.044 7.88.015 1.025-.005 1.673-.339 1.662-.85"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    r: 4.668,
    cy: 170.22,
    cx: 223.14
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#30AFEF",
    strokeLinecap: "round",
    strokeWidth: 0.6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39.675 2.59 7.243 7.244"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.60007498,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m209.52 177.52 7.243-7.243",
    transform: "translate(-169.845 -167.69)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 13.8631994,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#30AFEF",
      stroke: "#30AFEF",
      strokeWidth: 13.8631994,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "M236.6 271.6c4.6 5.7 11.5 9.4 19.4 9.4 13.8 0 25-11.2 25-25 0-7.3-3.2-13.8-8.2-18.4-.6-.7-1.3-1.5-2.2-2.2 0 0-117.7-87.5-120.3-85.2-2.6 2.3 85.3 120.2 85.3 120.2.2.4.7.8 1 1.2z",
    transform: "matrix(.0197 0 0 .0197 26.834 15.909)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 8.05999965,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      fillOpacity: 1
    },
    d: "M256.2 48h-.2v112h16V65.3c97.8 8.3 175.3 90.5 175.3 190.5 0 105.5-85.7 191.4-191.2 191.4-105.5 0-191.3-85.8-191.3-191.3 0-52.8 21.5-100.6 56.1-135.2L109 108.9C71.3 146.6 48 198.6 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208S371 48 256.2 48Z",
    transform: "matrix(.0197 0 0 .0197 26.834 15.909)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.674 21.945c-.513 0-1.027.211-1.36.604-.302.363-.846-.12-.544-.484a2.543 2.543 0 0 1 1.904-.846c.726 0 1.421.302 1.905.846.302.363-.242.847-.544.484-.333-.393-.847-.604-1.36-.604zm0 2.538a.735.735 0 0 1-.725-.725c0-.393.333-.725.725-.725.393 0 .726.332.726.725a.735.735 0 0 1-.726.725zm0-4.352c-.967 0-1.843.333-2.538 1.028-.303.302-.877-.151-.514-.514.816-.816 1.904-1.24 3.052-1.24 1.149 0 2.237.424 3.053 1.24.363.363-.212.816-.514.514-.695-.695-1.571-1.028-2.539-1.028zm0-1.813c-1.39 0-2.69.514-3.687 1.45-.362.333-.876-.18-.514-.513 1.18-1.088 2.63-1.663 4.201-1.663 1.572 0 3.023.575 4.202 1.663.362.332-.152.846-.514.513a5.343 5.343 0 0 0-3.688-1.45z",
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 0.345995,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 0.328083,
      strokeMiterlimit: 4,
      strokeDasharray: ".98425,.328083",
      strokeDashoffset: 0
    },
    d: "M60.29 21.038h8.833M38.226 21.038h8.834M16.692 20.951h8.834M16.692 21.118v-7.082",
    strokeDasharray: "0.98425, 0.328083",
    strokeWidth: 0.328
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 0.328083,
      strokeMiterlimit: 4,
      strokeDasharray: ".98425,.328083",
      strokeDashoffset: 0.360892
    },
    d: "M69.287 21.2v-6.633",
    strokeDasharray: "0.98425, 0.328083",
    strokeWidth: 0.328
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapUp);
export default __webpack_public_path__ + "static/media/wrapUp.262fe7bf4640ac694a7a068e1eec6102.svg";
export { ForwardRef as ReactComponent };